function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Divider } from '@homeaway/react-collapse';
import Tooltip from '@homeaway/react-tooltip';
import { SVGIcon } from '@homeaway/react-svg';
import { QUESTION__16 } from '@homeaway/svg-defs';
import PropTypes from 'prop-types';
import EventDocsRow from '../EventDocsRow/EventDocsRow';
import "./EventDocs.css";

var EventDocs = /*#__PURE__*/function (_Component) {
  _inheritsLoose(EventDocs, _Component);

  function EventDocs() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      expanded: _this.props.expanded,
      expandedEvents: {},
      parentNode: _this.parentNode
    };

    _this.handleEventExpansion = function (event) {
      var _extends2;

      var eventName = event.currentTarget.dataset.eventName;

      _this.setState({
        expandedEvents: _extends({}, _this.state.expandedEvents, (_extends2 = {}, _extends2[eventName] = !_this.state.expandedEvents[eventName], _extends2))
      });
    };

    _this.handleExpandedChange = function (isExpanded) {
      _this.setState({
        expanded: isExpanded
      });
    };

    _this.renderHeading = function () {
      return (_this.state.expanded ? 'Hide' : 'View') + " Event Tracking Information";
    };

    return _this;
  }

  var _proto = EventDocs.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      // eslint-disable-line react/no-did-mount-set-state
      parentNode: document.getElementsByTagName('body')[0]
    });
  };

  _proto.buildEvents = function buildEvents(events) {
    if (events === void 0) {
      events = [];
    }

    var uniqEvents = {};
    events.forEach(function (event) {
      var eventName = event.event;

      if (eventName) {
        if (!uniqEvents[eventName]) {
          uniqEvents[eventName] = [event];
        } else {
          uniqEvents[eventName].push(event);
        }
      }
    });
    return uniqEvents;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        componentName = _this$props.componentName,
        events = _this$props.events,
        expanded = _this$props.expanded;
    var _this$state = this.state,
        expandedEvents = _this$state.expandedEvents,
        parentNode = _this$state.parentNode; // An event can be triggered multiple times within a component.
    // buildEvents will build an object hashmap where the key is the unique
    // event name and the value is an array of the details for each trigger
    // of that event.

    var uniqEvents = this.buildEvents(events);
    return /*#__PURE__*/React.createElement(Divider, {
      onExpandedChange: this.handleExpandedChange,
      expanded: expanded,
      heading: this.renderHeading(),
      id: componentName + "-event-table-divider"
    }, /*#__PURE__*/React.createElement("div", {
      className: "EventDocs"
    }, /*#__PURE__*/React.createElement("svg", {
      width: "0",
      height: "0",
      style: {
        display: 'none'
      },
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
      id: "svg-alert-check",
      viewBox: "0 0 50 50"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M25 .4C11.4.4.4 11.4.4 25c0 13.6 11 24.6 24.6 24.6 13.6 0 24.6-11 24.6-24.6C49.6 11.4 38.6.4 25 .4zm-.4 35.2L14.3 25.2l2-2 7.6 7.5 9-16.3 2.7 1.5-11 19.6z"
    })))), /*#__PURE__*/React.createElement("table", {
      className: "EventDocs__table table table-hover"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      className: "EventDocs__th"
    }, 'Event Name'), /*#__PURE__*/React.createElement("th", {
      className: "EventDocs__th"
    }, 'Fields'), /*#__PURE__*/React.createElement("th", {
      className: "EventDocs__th"
    }, 'Options'), /*#__PURE__*/React.createElement("th", {
      className: "EventDocs__th"
    }, 'Invoking Method', ' ', /*#__PURE__*/React.createElement(Tooltip, {
      parentNode: parentNode,
      content: "This is the method or function within the component where this event is triggered."
    }, /*#__PURE__*/React.createElement(SVGIcon, {
      className: "text-link",
      inlineFlex: true,
      markup: QUESTION__16
    }))))), /*#__PURE__*/React.createElement("tbody", {
      key: "tbody",
      className: "EventDocs__tbody"
    }, Object.keys(uniqEvents).map(function (eventName, i) {
      // Get the array of objects that detail the
      // triggers for the given event name.
      var evtLocations = uniqEvents[eventName];

      if (evtLocations.length === 1) {
        var event = evtLocations[0];
        return /*#__PURE__*/React.createElement(EventDocsRow, {
          fields: event.fields,
          key: "row-" + eventName + "-" + i,
          method: event.method,
          name: eventName,
          options: event.options,
          parentNode: parentNode
        });
      }

      var isExpanded = !!expandedEvents[eventName];
      var elems = [/*#__PURE__*/React.createElement(EventDocsRow, {
        expander: evtLocations.length + " Methods",
        isExpanded: isExpanded,
        key: "row-" + eventName + "-" + i,
        name: eventName,
        onExpand: _this2.handleEventExpansion,
        parentNode: parentNode
      })];

      if (isExpanded) {
        elems = elems.concat(evtLocations.map(function (event, j) {
          return /*#__PURE__*/React.createElement(EventDocsRow, {
            fields: event.fields,
            isExpanded: isExpanded,
            key: "row-" + eventName + "-" + i + "-" + j,
            method: event.method,
            name: eventName,
            options: event.options,
            parentNode: parentNode
          });
        }));
      }

      return elems;
    })))));
  };

  return EventDocs;
}(Component);

EventDocs.propTypes = {
  /** Expand or collapse by default */
  expanded: PropTypes.bool,

  /** Name of component */
  events: PropTypes.arrayOf(PropTypes.shape({
    event: PropTypes.string,
    method: PropTypes.string,
    baseFilename: PropTypes.string,
    fields: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string
    })),
    options: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string
    }))
  }))
};
EventDocs.defaultProps = {
  events: [],
  expanded: true
};
export default EventDocs;
//# sourceMappingURL=EventDocs.js.map